import { Avatar }    from '@/components/ui/avatar';
import authStore     from '@/stores/authStore';
import { observer }  from 'mobx-react';

const NavBarAvatar = observer(() => {
	const currentUser = authStore.currentUser;
	return (
		<Avatar 
			bg="defaultBackground" 
			name={ currentUser?.fullName } 
			size="sm" 
			src={ currentUser?.userMediaProfilePicture }
			variant="outline" 
		/>
	);
});

export default NavBarAvatar